<template>
	<div class="trend-card">
		<Cell :border="false">
		  <div class="box">
			  <VanImage
				  width="3rem"
				  height="3rem"
				  class="box-left"
				  :src="data.marketImages && data.marketImages[0] && data.marketImages[0].imageUrl"/>
			  <div class="box-right">
				  <p class="title">{{ data.marketInfo && data.marketInfo.marketName }}</p>
				  <p class="text"><span>其他描述信息，开发中...</span><Button size="mini" type="danger" plain style="position: relative; left: -20px" @click="onTrendMore">更多</Button></p>
			  </div>

		  </div>
	  </Cell>
		<div class="chart-line">
		  <div class="chart" ref="line" id="line"></div>
	  </div>
	</div>
</template>

<script>
	import { Image as VanImage, Cell, Button } from 'vant'
  import ChartLine from '../components/chartLine.vue'
  import echarts from 'echarts';

	export default {
	  name: 'trendCard',
    components: { VanImage, Cell, Button, ChartLine },
		props: {
	    value: {},
			data: {
	      type: Object,
				default: () => {
				  return {}
				}
			}
		},
		mounted() {
			this.initChart();
		},
		methods: {
	    initChart() {
	      const that = this
	      const marketPrices = this.data.marketPrices;
	      let maxPrice = 0
        let minPrice = (marketPrices[0] && marketPrices[0].price) || 0
	      const xAxisData = marketPrices.map(v => {
	        const day = v['dateDay'].split('-')[2];
	        return `${day}号`;
	      })
		    const seriesData = marketPrices.map(v => {
		      if (maxPrice < v['price']) {
            maxPrice = v['price']
          }
          if (minPrice > v['price']) {
            minPrice = v['price']
          }
          return v['price'];
        })
        console.log(minPrice)
        const colors = ['#ee0a24', '#d14a61', '#675bba'];
        const myChart = echarts.init(this.$refs.line);
        myChart.setOption({
          color: colors,
          grid: {
            left: 60,
            top: 10,
            bottom: 30
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params, ticket, callback) {
              return that.data.marketPrices[params[0].dataIndex].dateDay + '：<br/>' + params[0].value + '元';
            }
          },
          xAxis: {
            data: xAxisData
          },
          yAxis: {
            min: minPrice,
            max: maxPrice
          },
          series: [
            {
              name: '数据',
              type: 'line',
              data: seriesData
            }
          ]
        })
        setTimeout(p => {
          myChart.dispatchAction({
            type: 'showTip',
            seriesIndex:0,  // 显示第几个series
            dataIndex: that.data.marketPrices.length - 1 // 显示第几个数据
          });
        }, 10)
	    },
      onTrendMore() {
	      this.$router.push({
		      name: 'trendDetail',
		      params: { ...this.data }
	      })
      }
		}
	}
</script>

<style lang="less" scoped>

	.trend-card {
		background: white;
	}

	.box {
		display: flex;

		&-left {
			padding-right: 15px;
		}

		.title {
			font-size: 14px;
			text-align: left;
			line-height: 20px;
		}

		.text {
			font-size: 12px;
			color: #646566;
			display: flex;
			justify-content: space-between;
		}
	}

	.btn-wrap {
		margin: 50px 30px;
	}

	.chart {
		width: 375px;
		height: 160px;
	}
</style>
